import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SrLink from 'client/components/SrLink/SrLink';
import branch from 'client/core/branch';

import { SCREEN_ID_LISTINGS } from 'client/constants/screenIds';

import ListingsListView from 'client/components/ListingsListView';

import getPinnedListingsAction from 'client/actions/Listing/getPinnedListings';

@branch({
  noResultsPinnedListings: ['noResultsPinnedListings'],
})
class NoResults extends Component {
  static propTypes = {
    noResultsPinnedListings: PropTypes.array,
    renterProfile: PropTypes.object.isRequired,
    householdApplications: PropTypes.array,
    bookmarksByListingId: PropTypes.object,
    currentUser: PropTypes.object.isRequired,
    photoResolution: PropTypes.number.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getPinnedListingsAction);
  }

  render() {
    const {
      noResultsPinnedListings,
      householdApplications,
      bookmarksByListingId,
      currentUser,
      photoResolution,
      renterProfile,
    } = this.props;

    return (
      <div>
        <div className="noResultsWrapper">
          <div className="noResults">
            <div className="arrow" />
            <span className="explainerText">
              Dang, no rentals match your search.
              <br />
              Please <SrLink to="/search">change the filter</SrLink> above.
            </span>
          </div>
        </div>
        {noResultsPinnedListings && noResultsPinnedListings.length !== 0 && (
          <div>
            <div className="noResultsPinnedListingsHeadline">
              <span>{`${noResultsPinnedListings.length} homes & apartments that got the most`}</span>
              <span className="heart" />
            </div>
            <ListingsListView
              savePositionWithId={SCREEN_ID_LISTINGS}
              listings={noResultsPinnedListings}
              isLoading={false}
              householdApplications={householdApplications}
              bookmarksByListingId={bookmarksByListingId}
              currentUser={currentUser}
              photoResolution={photoResolution}
              renterProfile={renterProfile}
            />
          </div>
        )}
      </div>
    );
  }
}

NoResults.displayName = 'NoResults';

export default NoResults;
